class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector("#predictive-search");

		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.then(() => {
				this.initializeVariantSelectors();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	open() {
		const header = document.querySelector("header");
		if (header.classList.contains("mm-open")) {
			this.predictiveSearchResults.style.zIndex = 2;
		}
		this.predictiveSearchResults.style.display = "block";
		document.querySelector("html").classList.add("stop-scrolling");
		document.querySelector("body").classList.add("stop-scrolling");

		this.querySelector(".mm-header-bg-filter").classList.add("mm-visible");

		const filterElement = this.querySelector(".mm-header-bg-filter");
		if (filterElement) {
			filterElement.classList.add("mm-visible");
			// Ajout de l'écouteur d'événements au moment de l'ouverture
			filterElement.addEventListener("click", this.close.bind(this));
		}

		const closeHeader = document.querySelector(".mm-header-burger .burger");
		// console.log(closeHeader);
		if (closeHeader) {
			closeHeader.addEventListener("click", this.close.bind(this));
		}
	}

	close() {
		const header = document.querySelector("header");
		if (header.classList.contains("mm-open")) {
			this.predictiveSearchResults.style.zIndex = 0;
		} else {
			document.querySelector("html").classList.remove("stop-scrolling");
			document.querySelector("body").classList.remove("stop-scrolling");
		}
		this.predictiveSearchResults.style.display = "none";

    // console.log("html", document.querySelector("html"));

		this.querySelector(".mm-header-bg-filter").classList.remove("mm-visible");
		// Réinitialisation de la valeur de l'input
		this.input.value = "";
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}

	/* Product cards variant selector */
	initializeVariantSelectors() {
		const variantSelectorAll = document.querySelectorAll(".mm-pc-variants-selector-container");
		variantSelectorAll.forEach( (variantSelector) => {
			variantSelector.addEventListener("change", (event) => {
				const selectedVariant = event.target.options[event.target.selectedIndex];
				const selectedId = selectedVariant.value;
				const productCard = variantSelector.closest(".mm-product-card")

				console.log(selectedVariant);
				//change CTA variant id
				productCard.dataset.variantId = selectedId;

				//change price
				const productPrice = productCard.querySelector(".mm-pc-price");
				const selectedPrice = selectedVariant.dataset.price;
				const priceFormatted = selectedPrice / 100
				let euros = Math.floor(priceFormatted);
				let cents = Math.round((priceFormatted - euros) * 100);
				productPrice.innerHTML = euros + "€" + (cents > 0 ? cents : "");

				//change selector qtty
				const quantity_in_cart = selectedVariant.dataset.cartQtty;
				if (quantity_in_cart) {
					productCard.querySelector(".quantity__input").innerText = quantity_in_cart;

					productCard.querySelector(".mm-quit-buy-container").classList.add("mm-styl-transition");
					productCard.querySelector(".mm-qb-btn-text").style.removeProperty("display");
					productCard.querySelector(".mm-pc-cta-container").style.display = "none";
					if (quantity_in_cart == 1) {
						productCard.querySelector(".mm-pc-delete-icon").style.removeProperty("display");
						productCard.querySelector(".mm-pc-minus-icon").style.display = "none";
					} else {
						productCard.querySelector(".mm-pc-minus-icon").style.removeProperty("display");
						productCard.querySelector(".mm-pc-delete-icon").style.display = "none";
					}
				} else {
					productCard.querySelector(".mm-quit-buy-container").classList.remove("mm-styl-transition");
					productCard.querySelector(".mm-pc-cta-container").style.removeProperty("display");
					productCard.querySelector(".mm-qb-btn-text").style.display = "none";
				}
			})
		})
	}
}

customElements.define('predictive-search', PredictiveSearch);
